module.exports = __webpack_public_path__ + "static/media/k.3a8bcd3b.png";